module.exports = "/images/tj.svg?7e3d0974923191e9a62e956dd3fa187d";